import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_TICKCURRENTPIECE_SCHEMA_LITERAL = {
    title: 'Schéma CurrentPiece',
    description: 'Ticket',
    version: 0,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        DC_PIECE : { type : 'string' }
    },
    required: [ 'MD_SITEGID', 'MD_SITE', 'MD_CAISSE', 'MD_CAISSE_SESSION', 'DC_PIECE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_TICKCURRENTPIECE_SCHEMA_LITERAL);
export type RxCluTickCurrentPieceDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_TICKCURRENTPIECE_SCHEMA: RxJsonSchema<RxCluTickCurrentPieceDocumentType> = CLU_TICKCURRENTPIECE_SCHEMA_LITERAL;
